import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import reduxStore from './../../../reduxStore';
import EditEntityExperianCheck from './EditEntityExperianCheck';
import ExperianLookupModal from './ExperianLookupModal';
import api from '../../../api/EditThirdParty.api';
import { forIn, find } from 'lodash';
import storage from "../../../utils/storage";
import {usStates, experianPageSize} from "../../../constants";
import utils from "../../../utils/utilities"

const experianFunctionMap = {
    country: "PUB-ADDR-COUNTRY",
    state: "PUB-ADDR-ST-CODE",
    city: "PUB-ADDR-CITY",
    address: "PUB-ADDR-STREET"
}
export default class EditEntityExperian extends React.Component {

    static propTypes = {
        experianBusinessId: PropTypes.string,
        entityName: PropTypes.string,
        entityId: PropTypes.string,
    };

    static defaultProps = {
        entityName: null,
        experianBusinessId: '',
        entityId: null
    };

    constructor(props) {
        super(props);

        this.state = {
            emptyExperianError: false,
            experian : this.props.experianBusinessId,
            isExperianInputDisabled: false,
            experianPopoverOpen: false,
            experianResponse: null,
            experianLookupResponse: null,
            experianLookupError: null
        };

        this.user = reduxStore.getState().user;

        this.changeExperian = this.changeExperian.bind(this);
        this.validateExperianFormat = this.validateExperianFormat.bind(this);
        this.blurAction = this.blurAction.bind(this);
        this.showExperianModal = this.showExperianModal.bind(this);
        this.closeExperianModal = this.closeExperianModal.bind(this);
        this.fetchExperianData = this.fetchExperianData.bind(this);
        this.validateExperianID = this.validateExperianID.bind(this);
        this.chooseExperian = this.chooseExperian.bind(this);
    }

    componentDidMount() {
        if (this.state.experian.length) {
            this.validateExperianID()
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.experianBusinessId !== this.props.experianBusinessId) {
            this.setState({ experian: nextProps.experianBusinessId }, this.validateExperianFormat)
        }
        if (nextProps.entityName != this.props.entityName) {
            this.setState({ experianResponse: null })
        }
    }

    showExperianModal() {
        this.fetchExperianData(this.props.entityName)
        this.setState({ experianPopoverOpen: true })
    }

    closeExperianModal() {
        this.setState({ experianPopoverOpen: false, isExperianInputDisabled: false })
    }

    changeExperian(event) {
        let userInput  = event.target.value;
        this.setState({ experian: userInput, experianResponse: null }, this.validateExperianFormat);
    }

    validateExperianID() {
        this.setState({
            isExperianInputDisabled: true,
            experianResponse: { loading: true }
        });
        if(this.props.entityId) {
            return api.queryExperianId(this.state.experian, this.props.entityId).then((response) => {
                const processedDoc = response.body.processedDoc;
                const htmlDoc = response.body.htmlDoc;

                const body      = htmlDoc;
                const title     = processedDoc.title;
                const company   = processedDoc.company;
                const address   = processedDoc.address;

                this.setState({
                    experianResponse: { title, body, company, address, success: true },
                    isExperianInputDisabled: false
                })
            }).catch((error) => {
                this.setState({
                    experianResponse: { title: null, body: null, address: null, success: false },
                    isExperianInputDisabled: false
                })
            });
        } else {
            return api.queryExperianId(this.state.experian).then((response) => {
                let auth = storage.getObject("lnei");
                let isWam = (auth && auth.authInfo && auth.authInfo.type === "WAM");
                if (isWam) {

                    const body      = response.body.text;
                    const title     = response.body.title;
                    const company   = response.body.processedDoc.company;
                    const address   = response.body.processedDoc.address;

                    this.setState({
                        experianResponse: { title, body, company, address, success: true },
                        isExperianInputDisabled: false
                    })
                } else {
                    let el = document.createElement( 'html' );
                    el.innerHTML = `<html>${response.text}</html>`;

                    const body      = response.text;
                    const title     = el.getElementsByTagName("title")[0].innerText;
                    const company   = el.getElementsByClassName("PUB-COMPANY")[0].innerText;
                    const address   = el.getElementsByClassName("DISPLAY-ADDR1")[0].innerText;

                    this.setState({
                        experianResponse: { title, body, company, address, success: true },
                        isExperianInputDisabled: false
                    })
                }
            }).catch((error) => {
                this.setState({
                    experianResponse: { title: null, body: null, address: null, success: false },
                    isExperianInputDisabled: false
                })
            });
        }

    }

    fetchExperianData(name, meta = null, page = 0) {
        if (name && name.trim().length) {
            this.setState({
                isExperianInputDisabled: true,
                experianLookupResponse: null,
                experianLookupError: null
            })

            let auth = storage.getObject("lnei");
            let isWam = (auth && auth.authInfo && auth.authInfo.type === "WAM");
            if (isWam) {
                let state = null;
                if (meta && meta['state']) {
                    let stateObj = find(usStates, function(data) {return data.abbreviation === meta['state']});
                    if (stateObj) state = utils.capitalizeWords(stateObj.name);
                }

                let q = {
                    "company": name,
                    "country": "UNITED STATES",
                    "state": state,
                    "city": meta ? meta["city"] : null,
                    "street": meta && meta["address"] ? meta["address"] : null,
                    "from": page * experianPageSize,
                    "size": experianPageSize
                }



                return api.queryEsExperian(q).then((response) => {
                    if (response.body && response.body.experianCompanyTOs) {
                        this.setState({
                            isExperianInputDisabled: false,
                            experianLookupResponse: response.body,
                            experianLookupError: null
                        })
                    } else {
                        this.setState({
                            isExperianInputDisabled: false,
                            experianLookupResponse: false,
                            experianLookupError: null
                        })
                    }
                }).catch((error) => {
                    console.log("=========", error);

                    let experianLookupError = null
                    if (error.response.statusCode === 400 && error.response.body.detail.errorDetail.errorCode) {
                        if(error.response.body.detail.errorDetail.errorCode === "SEARCH_TOO_GENERAL") {
                            experianLookupError = "Entities_Edit_UIText_editThirdParty.experianSearchTooGeneral"
                        }
                    }
                    this.setState({
                        isExperianInputDisabled: false,
                        experianLookupResponse: false,
                        experianLookupError: experianLookupError
                    })
                });

            } else {
                let query = `COMPANY(${name})`
                if (meta !== null) {
                    forIn(meta, (value, key) => {
                        if (value && value.trim().length) {
                            query += ` AND ${experianFunctionMap[key]}(${value})`
                        }
                    })
                }
                query = encodeURIComponent(query)
                return api.queryExperian(query, page).then((response) => {
                    if (response.body && response.body.experianCompanyTOs) {
                        this.setState({
                            isExperianInputDisabled: false,
                            experianLookupResponse: response.body,
                            experianLookupError: null
                        })
                    } else {
                        this.setState({
                            isExperianInputDisabled: false,
                            experianLookupResponse: false,
                            experianLookupError: null
                        })
                    }
                }).catch((error) => {
                    let experianLookupError = null
                    if (error.response.statusCode === 400 && error.response.body.detail.errorDetail.errorCode) {
                        if(error.response.body.detail.errorDetail.errorCode === "SEARCH_TOO_GENERAL") {
                            experianLookupError = "Entities_Edit_UIText_editThirdParty.experianSearchTooGeneral"
                        }
                    }
                    this.setState({
                        isExperianInputDisabled: false,
                        experianLookupResponse: false,
                        experianLookupError: experianLookupError
                    })
                });
            }

        } else {
            this.setState({ experianLookupResponse: false, experianLookupError: null })
        }
    }


    validateExperianFormat(showErrorMessage = true) {
        let regEx      = /^[0-9]{9}$/,
            validInput = regEx.test(this.state.experian);

        if (showErrorMessage) {
            this.setState({ emptyExperianError: !validInput });
        }

        return validInput;
    }

    chooseExperian(experian) {
        this.setState({ experian: experian, isExperianInputDisabled: false, experianResponse: null }, () => {
            this.validateExperianID();
            this.props.onBlur("experianBusinessId", experian);

            this.closeExperianModal();
        });
    }

    blurAction() {
        if (!this.state.emptyExperianError && this.props.experianBusinessId !== this.state.experian) {
            this.setState({ experianResponse: null }, () => {
                this.props.onBlur("experianBusinessId", this.state.experian);
            })

        }
    }

    render() {
        let experianResult = null
        if (this.state.experianResponse !== null) {
            experianResult = this.state.experianResponse.success && (
                <div className={'edit-third-party__about__experian-address'}>
                    {this.state.experianResponse.company} - {this.state.experianResponse.address}
                </div>
            )
        }

        return (
            <div className="edit-third-party__about__input-group">
                <div className="row-label">
                    <label htmlFor="edit-third-party__about__experian" className="edit-third-party__experian-label">
                        <div>
                            <FormattedMessage id="Entities_Edit_UIText_editThirdParty.experianLabel" />
                            {this.props.isRequiredField ? <span className="required-field-star" /> : null}
                        </div>
                        {this.user.appSettings.isExperianEnabled && (
                            <a className="action-link experian-lookup-link" onClick={this.showExperianModal}>
                                <FormattedMessage id="Entities_Edit_UIText_editThirdParty.lookUp" />
                            </a>
                        )}
                    </label>
                </div>
                <input type="text"
                       maxLength="9"
                       id="edit-third-party__about__experian"
                       name="experianBusinessId"
                       value={this.state.experian}
                       onChange={this.changeExperian}
                       onBlur={this.blurAction}
                       disabled={this.state.isExperianInputDisabled}
                />

                <div className={'edit-third-party__about__empty-experian-error' +
                (this.state.emptyExperianError ? '' : ' hidden')}>
                    <FormattedMessage id="Entities_Edit_UIText_editThirdParty.experianTip" />
                </div>

                {
                    this.user.appSettings.isExperianEnabled && !this.props.hideExperianCheckButton && !this.state.emptyExperianError ?
                        <EditEntityExperianCheck
                            checkExperian={this.validateExperianID}
                            experianResponse={this.state.experianResponse}
                            toggleExperianInputDisable={this.toggleExperianInputDisable}
                        />
                        :
                        null
                }

                {(this.user.appSettings.isExperianEnabled && this.state.experianPopoverOpen) && (
                    <ExperianLookupModal
                        closeModal={this.closeExperianModal}
                        experianResponse={this.state.experianLookupResponse}
                        experianCall={this.fetchExperianData}
                        entityName={this.props.entityName}
                        chooseExperian={this.chooseExperian}
                        experianError={this.state.experianLookupError}
                    />
                )}

                {experianResult}
            </div>
        );

    }

}



// WEBPACK FOOTER //
// ./src/scripts/pages/EditThirdParty/components/EditEntityExperian.jsx